/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : Sales spikes detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { Loader } from "../../../Component/Others";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { PrimaryButton, TextButton } from "../../../Component/Buttons";
import { DataTableComponent } from "../../../Component/DataTable";
import { CustomSelectBox } from "../../../Component/FormElements";
import { EmptyScreen } from "../../../Component/EmptyComponent";
import { PauseRewardModal } from "../../../Component/Modal";
import { Modal } from "bootstrap";
import { APIService } from "../../../Service";
import Store from "../../../Store/store";

const ITEMS_PER_PAGE = 20;

const PAGE_SORT_FIELDS = [
    'id',
    'date',
    'invoice_number',
    'volume',
];

const SalesSpikesDetail = () => {

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);
    const tableRef = useRef(null);
    const isSortingRef = useRef(false);

    const navigate = useNavigate();
    const { state } = useLocation();

    const [adminType, setAdminType] = useState(Cookies.get("admin_type") === "1" ? "super_admin" : "country_admin");

    const [toggleFilter, setToggleFilter] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pauseModal, setPauseModal] = useState(false);
    const [isPause, setIsPause] = useState(false);

    const [tableLoader, setTableLoader] = useState(false);
    const [clearFilter, setClearFilter] = useState(false);

    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);



    const [detailData, setDetailData] = useState({});
    const [listData, setListData] = useState({});

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });

        _getSalesHistoryFilterData();
    }, []);

    useEffect(() => {
        if (state !== null && state?.id) {
            _getDetailData();
        }
    }, [state]);

    useEffect(() => {
        if (PROFILE_DATA && PROFILE_DATA.reward_enabled === false) {
            setIsPause(true);
        }
    }, [PROFILE_DATA]);

    useEffect(() => {
        if (pauseModal === true) {
            const modal = new Modal(document.getElementById('pause-reward-modal'));
            modal.show();
        }
    }, [pauseModal]);

    useEffect(() => {
        if (clearFilter === true) {
            _getSalesHistory(currentPage);
        }
    }, [clearFilter]);

    // handle paginate store list 
    const _handlePageChange = (page_num) => {
        if (isSortingRef.current) {
            isSortingRef.current = false;
            return;
        }

        if (page_num === currentPage) {
            return;
        }

        setCurrentPage(page_num);

        if (tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth' });
        }

        _getSalesHistory(page_num);

    };

    const _handleSort = (column, direction) => {
        const sortBy = column.sortField || column.id || null;

        if (!sortBy || !PAGE_SORT_FIELDS.includes(sortBy)) {
            return;
        }

        isSortingRef.current = true;
        setSortField(sortBy);
        setSortDirection(direction);
        setCurrentPage(1);
        _getSalesHistory(1, sortBy, direction);

        setTimeout(() => {
            isSortingRef.current = false;
        }, 0);
    };

    const _handleClearAll = () => {
        setClearFilter(true);
        setCurrentPage(1);
        setSortField(null);
        setSortDirection(null);

        setSelectedPeriod(filterData[0]);
    };

    // API - Get profile api
    const _getProfile = () => {
        let is_post = false;
        let url = adminType === "super_admin" ? 'profile/get' : 'CA/profile/get';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'UPDATE_PROFILE_DATA',
                    payload: response.data
                });
            } else { }
        });
    };

    const [loader, setLoader] = useState(true);

    // API - Get detail data
    const _getDetailData = () => {
        let is_post = true;
        let url = 'CA/sales-spike/detail';
        let data = {
            "transaction_id": state?.id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                // setListData(response.data.sales_history);
                setDetailData(response.data);

            } else {
                // setListData([]);
                setDetailData({});
            }
            setLoader(false);
            _getSalesHistory(currentPage);
        });
    };

    // API - Get sales history
    const _getSalesHistory = (page_num = currentPage, sort_by = sortField, sort_order = sortDirection) => {
        const effective_sort_by = sort_by && PAGE_SORT_FIELDS.includes(sort_by) ? sort_by : null;
        const effective_sort_order = effective_sort_by ? sort_order : null;

        setTableLoader(true);

        let is_post = true;
        let url = 'CA/sales-spike/sales-history';
        let data = {
            "transaction_id": state?.id,
            "page_num": page_num,
            "limit": ITEMS_PER_PAGE,
            "sales_period": selectedPeriod?.value || null,
            "sort_by": effective_sort_by ? [effective_sort_by] : null,
            "order": effective_sort_order ? [effective_sort_order] : null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListData(response.data);
            } else {
                setListData({});
            }
            setTableLoader(false);
            setClearFilter(false);
        });
    };

    const [filterData, setFilterData] = useState({});
    const [filterLoader, setFilterLoader] = useState(false);

    // API - Get sales history filter data
    const _getSalesHistoryFilterData = () => {
        setFilterLoader(true);
        let is_post = false;
        let url = 'CA/sales-spike/sales-history/filter-data';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                let updated_data = [
                    { value: null, label: "All" },
                    ...response.data.sales_period
                ];

                setFilterData(updated_data);

                setSelectedPeriod(updated_data[0]);
            } else {
                setFilterData({});
            }
            setFilterLoader(false);
        });
    };

    // Table columns
    const TABLE_COLUMNS = [
        {
            name: 'Date',
            id: 'date',
            sortField: 'date',
            selector: row => row.date || '-',
            cell: row => <>{row.date || '-'}</>,
            format: row => row.date,
            width: "200px",
            sortable: true
        },
        {
            name: 'Invoice No',
            id: 'invoice_number',
            sortField: 'invoice_number',
            selector: row => row.invoice_number || "-",
            cell: row => <>{row.invoice_number || "-"}</>,
            width: "200px",
            sortable: true
        },
        {
            name: PROFILE_DATA.country === "Egypt" ? 'Volume (U)' : 'Volume (L)',
            id: 'volume',
            sortField: 'volume',
            selector: row => row.volume || "-",
            cell: row => <>{row.volume || "-"}</>,
            width: "200px",
            sortable: true
        },
    ];



    return (
        <section className='pb-5'>
            <div className='e-bg-lavender-blush-light padding-12px-top padding-98px-bottom  padding-52px-lr'>
                <div className='e-display-flex cursor-pointer w-max-content'
                    onClick={() => navigate("/manage-fraud")} >
                    <img src={require("../../../Assets/Image/CountryAdmin/arrow-left.svg").default}
                        draggable={false}
                        className='cursor-pointer'
                        alt='arrow'
                    />
                    <h1 className='ps-1 mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                        Spike details
                    </h1>
                </div>
            </div>

            {loader ?
                <Loader />
                :
                <div className='margin-neg-66px-top padding-52px-lr'>
                    <div className='e-admin-box-shadow e-bg-white e-border-radius-16 px-4 padding-34px-tb position-relative'>
                        <div className='d-flex justify-content-between align-items-center gap-2 flex-wrap'>
                            <div >
                                <div className='d-flex align-items-center gap-14px'>
                                    <div className="e-bg-platinum e-border-radius-50per">
                                        <img src={detailData.profile_img ? detailData.profile_img :
                                            require("../../../Assets/Image/SuperAdmin/admin-profile.svg").default}
                                            draggable={false}
                                            className={`${detailData.profile_img ? 'e-bg-platinum p-1' : ''} e-bg-platinum e-border-radius-50per`}
                                            height={52}
                                            width={52}
                                            alt='profile' />
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center gap-2">
                                            <div className={`${detailData?.sales_specialist?.active_status?.toLowerCase() === "active" ? "e-text-philippine-green e-bg-crystal-quartz" : "e-text-bright-orange e-bg-silent-white"}  e-border-radius-16 padding-2px-tb px-2 d-flex w-max-content `}>
                                                <span className={` e-alt-font-noto-sans e-font-8 e-font-weight-500 line-height-10px`}>
                                                    {detailData.sales_specialist.active_status}
                                                </span>
                                            </div>

                                            {detailData.sales_specialist.is_flagged === true &&
                                                <div className="e-bg-silent-white e-border-radius-16 padding-2px-tb px-2 d-flex w-max-content">
                                                    <span className="e-text-bright-orange e-alt-font-noto-sans e-font-8 e-font-weight-500 line-height-10px">
                                                        Flagged for review
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                        <p className='mb-0 pt-1 e-primary-font-playfair e-text-rich-black e-font-20 e-font-weight-600 line-height-26px'>
                                            {detailData.sales_specialist?.name || "-"}
                                        </p>
                                    </div>
                                </div>

                                <div className='pt-2 d-flex flex-column gap-1'>
                                    <a href={`tel:${detailData?.sales_specialist?.phone}`} className='e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px w-max-content text-decoration-none text-decoration-hover-underline'>
                                        {detailData?.sales_specialist?.phone || "-"}
                                    </a>
                                    <a href={`mailto:${detailData?.sales_specialist?.email}`} className='e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px w-max-content text-decoration-none text-decoration-hover-underline'>
                                        {detailData?.sales_specialist?.email || "-"}
                                    </a>
                                </div>
                            </div>
                            <div className="d-flex align-items-end gap-30px">
                                <div className='e-bg-beautiful-white e-border-radius-8 p-3' style={{ width: "448px" }}>
                                    <div className='row row-gap-3 justify-content-between'>
                                        <div className='col-xl-auto col-lg-4 col-md-6 col-6'>
                                            <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                Volume
                                            </p>
                                            <p className='mb-0 pt-xl-4 pt-1 e-text-rich-black e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-20px'>
                                                {detailData?.spike_metrics?.volume || "-"}
                                            </p>
                                        </div>
                                        <div className='col-xl-auto col-lg-4 col-md-6 col-6'>
                                            <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                Sales amount
                                            </p>
                                            <p className='mb-0 pt-xl-4 pt-1 e-text-rich-black e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-20px'>
                                                {detailData?.spike_metrics?.sales_amount || "-"}
                                            </p>
                                        </div>
                                        <div className='col-xl-auto col-lg-4 col-md-6 col-6 '>
                                            <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                Spike
                                            </p>
                                            <p className='mb-0 pt-xl-4 pt-1 e-text-rich-black e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-20px'>
                                                {detailData?.spike_metrics?.spike_percent || "-"}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <PrimaryButton name={isPause ? "Resume rewards" : "Pause rewards"}
                                    className="e-border-radius-16 px-3 py-2"
                                    onPress={() => setPauseModal(true)} />
                            </div>
                        </div>
                    </div>


                    <div ref={tableRef} className='e-bg-white e-border-1px-platinum-dark e-admin-box-shadow py-4 e-border-radius-16 mt-4'>
                        <div className='px-4 pb-3 d-flex align-items-center justify-content-between'>
                            <h4 className='mb-0 e-text-rich-black e-alt-font-noto-sans e-font-18 e-font-weight-500 line-height-18px' >
                                Sales history
                            </h4>

                            <div className='d-flex justify-content-end align-items-center gap-4'>
                                <div className={filterLoader ? "pe-none opacity-75" : ""}>
                                    <img src={toggleFilter ? require("../../../Assets/Image/filter-icon-white.svg").default : require("../../../Assets/Image/filter-icon.svg").default}
                                        draggable={false}
                                        height={40}
                                        width={40}
                                        className={` ${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-anti-flash-white e-border-radius-8 p-2 cursor-pointer`}
                                        alt='filter'
                                        onClick={() => setToggleFilter(!toggleFilter)} />
                                </div>
                            </div>
                        </div>


                        {/* filter */}
                        {toggleFilter &&
                            <div className='e-bg-anti-flash-white-dark py-3 px-4'>
                                <div className='row'>
                                    <div className='col-md-3 col-sm-4 col-6'>
                                        <CustomSelectBox label="Sales period"
                                            value={selectedPeriod}
                                            options={filterData}
                                            // loader={filterLoader}
                                            type={2}
                                            className="e-bg-white e-border-radius-4 e-table-select"
                                            minHeight="34px"
                                            padding="0 8px"
                                            wrapperHeight="0px"
                                            labelClass="e-font-weight-600"
                                            optional={true}
                                            isSearchable={false}
                                            selectChange={(value) => setSelectedPeriod(value)}
                                        />
                                    </div>

                                    <div className='col-md-3 col-sm-4 col-6 mt-auto'>
                                        <div className='d-flex gap-3 align-items-center '>
                                            <TextButton name="Clear all"
                                                onPress={_handleClearAll} />
                                            <PrimaryButton name="Filter now"
                                                className="px-3 py-1 e-border-radius-8"
                                                onPress={() => {
                                                    setCurrentPage(1);
                                                    _getSalesHistory(1);
                                                }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {tableLoader ?
                            <Loader />
                            :
                            Object.keys(listData).length !== 0 && listData?.sales_history?.length !== 0 ?
                                <div className={`e-table no-strip no-hover`} >
                                    <DataTableComponent
                                        key={`sales-spike-history-${currentPage}-${sortField || 'none'}-${sortDirection || 'none'}`}
                                        columns={TABLE_COLUMNS}
                                        pagination={true}
                                        data={listData.sales_history}
                                        paginationPerPage={ITEMS_PER_PAGE}
                                        paginationServer={true}
                                        paginationTotalRows={listData.total_count}
                                        paginationDefaultPage={currentPage}
                                        paginationResetDefaultPage={false}
                                        sortServer={true}
                                        defaultSortFieldId={sortField}
                                        defaultSortAsc={sortDirection !== 'desc'}
                                        onSort={_handleSort}
                                        onChangePage={_handlePageChange} />
                                </div>
                                :
                                <div className='h-100vh py-5 my-5'>
                                    <EmptyScreen message="No data found" />
                                </div>
                        }
                    </div>
                </div >
            }


            {
                pauseModal === true &&
                <PauseRewardModal title={isPause ? "Resume reward?" : "Pause reward?"}
                    description={isPause ? "By clicking Resume reward, user will be allowed to start redeeming again" :
                        <>
                            Pausing this reward will temporarily stop users from earning and redeeming it.
                            The reward details and history will remain visible.
                            <div className='pt-2'>You can resume this reward anytime.</div>
                        </>}
                    primaryButtonLabel={isPause ? "Resume reward" : "Pause reward"}
                    handleClose={() => {
                        setTimeout(() => {
                            setPauseModal(false);
                        }, 200);
                    }}

                    handleSuccess={() => {
                        setTimeout(() => {
                            setPauseModal(false);
                            setIsPause(prev => !prev);
                            _getProfile();
                        }, 200);
                    }}
                />
            }
        </section >
    )
}

export default SalesSpikesDetail;
